import React from 'react';
import {FormattedMessage} from 'react-intl';
import CSSTransition from 'react-transition-group/CSSTransition';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import PropTypes from 'prop-types';

import './SearchAreaButton.less';

const SearchAreaButton = ({isVisible, onClick, isDisabled, isLoading}) => (
    <div>
        <CSSTransition
            in={isVisible}
            classNames="Search__transition"
            timeout={400}
            mountOnEnter
            unmountOnExit
        >
            <div className="Map__search" data-wdio="Map__search">
                <button
                    key="searchareaShow"
                    type="button"
                    className="btn btn-primary"
                    onClick={onClick}
                    data-wdio="Map__search"
                    disabled={isDisabled}
                >
                    <FormattedMessage
                        id="searchThisArea"
                        description="Search this area"
                        defaultMessage="Search this area"
                    />
                </button>
            </div>
        </CSSTransition>
        <LoadingOverlay loading={isLoading} />
    </div>
);

SearchAreaButton.propTypes = {
    isVisible: PropTypes.bool,
    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
};

SearchAreaButton.defaultProps = {
    isLoading: false,
    isDisabled: false,
    isVisible: false,
};

export default SearchAreaButton;
